<template>
  <v-container fluid v-if="loadedSettings">
    <v-form>
      <v-card outlined class="mb-5">
        <v-container fluid>
          <v-row>
            <v-col>
              <v-text-field :label="$t('settings.pdfLogo')" v-model="loadedSettings.logo_header_url" :disabled="loading"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                  :label="$t('settings.footerText')"
                  v-model="loadedSettings.footer_text"
                  :disabled="loading"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row v-if="loadedSettings.display_fields">
            <v-col>
              <v-switch
                  v-model="loadedSettings.display_fields.email"
                  :label="$t('settings.displayFields.email')"
              />
              <v-switch
                  v-model="loadedSettings.display_fields.phone"
                  :label="$t('settings.displayFields.phone')"
              />
              <v-switch
                  v-model="loadedSettings.display_fields.barcode"
                  :label="$t('settings.displayFields.barcode')"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "SlipDeliverySettings",
  props: {
    loadedSettings: {
      type: Object,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
}
</script>
